import { Component, OnInit, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { UntypedFormBuilder } from '@angular/forms';
import { ComponentBase } from '../../../core/_infrastructure/classes/componentBase';
import { GlobalService } from '../../../core/_infrastructure/classes/services/global.service';
import { CodigoEppoService } from './codigoeppo.service';
import { HttpParams } from '@angular/common/http';
import { ConfirmationService, SelectItem } from 'primeng/api';
import { NotificationService } from '../../../core/_infrastructure/classes/services/notification.service';
import { ExceptionManager } from '../../../core/_infrastructure/classes/handlers/exceptionManager';
import { AuthService } from '../../../core/_infrastructure/classes/services/auth.service';
import { Table } from 'primeng/table';
import { TwTcEppoItemResultsViewModel, TwTcEppoViewModel, EnumSiNoTodos } from 'src/app/components/core/_infrastructure/types/common';
import { FilterSearchingCodigoEppoViewModel } from './codigoeppo.types';

@Component({
    selector: 'app-codigoeppo-list',
    templateUrl: './codigoeppo-list.component.html',
})
export class CodigoEppoListComponent extends ComponentBase implements OnInit {
    @ViewChild('tableSearch') turboTable: Table;

    listSiNoTodos: SelectItem[];
    resultCodigosEppo: TwTcEppoItemResultsViewModel;
    cols: any[];
    public isCollapsed = false;

    visibilitySpinner: boolean = false;

    constructor(
        private router: Router,
        private fb: UntypedFormBuilder,
        private globalService: GlobalService,
        protected notificacionService: NotificationService,
        protected authService: AuthService,
        protected exceptionHandler: ExceptionManager,
        private confirmationService: ConfirmationService,
        private codigoEppoService: CodigoEppoService,
    ) {
        super(authService, notificacionService, exceptionHandler);

        this.resultCodigosEppo = new TwTcEppoItemResultsViewModel();
    }

    ngOnInit() {
        this.cols = [
            { field: 'Link', header: '' },
            { field: 'Id', header: 'Id', display: 'none' },
            { field: 'CodigoEppo', header: 'Código Eppo' },
            { field: 'InvasivaNoPermitida', header: 'Invasora no permitida' },
        ];

        this.form = this.fb.group({
            CodigoEppo: '',
            InvasivaNoPermitida: EnumSiNoTodos.TODOS,
        });

        //p-selectButton
        this.listSiNoTodos = [
            { label: 'Sí', value: EnumSiNoTodos.SI },
            { label: 'NO', value: EnumSiNoTodos.NO },
            { label: 'TODOS', value: EnumSiNoTodos.TODOS },
        ];

        this.loadBack();
    }

    loadBack() {
        if (
            this.codigoEppoService.currentFilterCodigoEppo.CodigoEppo != '' ||
            this.codigoEppoService.currentFilterCodigoEppo.InvasivaNoPermitida != EnumSiNoTodos.TODOS
        ) {
            this.form.patchValue({
                CodigoEppo: this.codigoEppoService.currentFilterCodigoEppo.CodigoEppo,
                InvasivaNoPermitida: this.codigoEppoService.currentFilterCodigoEppo.InvasivaNoPermitida,
            });

            this.onSearchButton();
        }
    }

    onSearchButton() {
        if (this.turboTable) {
            this.turboTable.first = 0;
        }

        this.Search(0);

        //let params = new HttpParams();

        this.codigoEppoService.currentFilterCodigoEppo.CodigoEppo = this.form.value.CodigoEppo;
        this.codigoEppoService.currentFilterCodigoEppo.InvasivaNoPermitida = this.form.value.InvasivaNoPermitida;

        this.searchingButton = true;
        this.isCollapsed = true;
    }

    Search(pageNumber: number, asc: number = 0, orderBy: string = '') {
        let params = new HttpParams();

        params = params.append('pageNumber', pageNumber.toString());
        params = params.append('asc', asc.toString());
        params = params.append('orderBy', orderBy);
        params = params.append('codigoEppo', this.form.value.CodigoEppo);
        params = params.append('invasivanopermitida', this.form.value.InvasivaNoPermitida);

        this.loading = true;

        //valdrían las dos llamadas, pero se ha quitado del codigoepposervice y se ha dejado en globalService
        //this.codigoEppoService.getCodigoEppoPagedByFilter(params).subscribe(result => {
        this.globalService.getCodigoEppoPagedByFilter(params).subscribe(result => {
            this.resultCodigosEppo = result;
            this.loading = false;
        });
    }

    onSearchLazy(event: any) {
        if (!event.rows || event.sortField == 'Link') {
            return;
        }

        let pageNumber = event.first / event.rows;
        this.Search(pageNumber, event.sortOrder, event.sortField);
    }

    onCleanButton() {
        this.form.setValue({
            CodigoEppo: '',
            InvasivaNoPermitida: false,
        });
        this.searchingButton = false;
        this.isCollapsed = false;

        this.resultCodigosEppo = new TwTcEppoItemResultsViewModel();
    }

    onAdd() {
        this.router.navigate(['/mantenimiento/especies/codigoseppo/create']);
    }

    onEdit(item: TwTcEppoViewModel) {
        this.router.navigate(['/mantenimiento/especies/codigoseppo/edit', item.Id]);
    }

    onDelete(item: TwTcEppoViewModel) {
        this.confirmationService.confirm({
            message: '¿Está seguro?',
            accept: () => {
                //Actual logic to perform a confirmation
                this.codigoEppoService.deleteCodigoEppo(item.Id).subscribe({
                    next: res => {
                        this.addSuccessMessage('Código Eppo eliminado correctamente');
                        this.onSearchButton();
                    },
                    error: error => {
                        ////es un businessValidationException generado en el service
                        //if (error.error[0]!.key == "codigoeppo_used") {
                        //    this.addErrorMessage("El Código Eppo no se puede eliminar porque está asociado a algún nombre cientí­fico");
                        //}
                        //else
                        this.catchServerError(error);
                    },
                });
            },
        });
    }

    CreateModel() {
        let model: FilterSearchingCodigoEppoViewModel = new FilterSearchingCodigoEppoViewModel();

        Object.assign(model, this.form.value);

        return model;
    }

    onExportExcel() {
        this.visibilitySpinner = true;

        this.codigoEppoService.export(this.CreateModel()).subscribe(res => {
            this.OpenDownloadedFile(res);

            //window.open(fileURL);
            this.visibilitySpinner = false;
        });
    }
}
